import { Box, FormControl } from "@primer/react";
import { useState } from "react";

import Button from "../../components/ui/button";
import Modal from "../../components/ui/modal";
import ModalActions from "../../components/ui/modal/ModalActions";

import ComboboxLop from "../../components/combobox-lop";

import { hocSinhApi } from "../../api/hocSinhApi";
import { meetingPickApi } from "../../api/meetingPickApi";

import { NotifyHelper } from "../../helpers/toast";
import { useAuth } from "../../hooks/useAuth";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";

import MeetingPickGrid from "./MeetingPickGrid";
import TextInput from "../../components/ui/text-input";

interface Props {
    isOpen: boolean;
    id: number;
    onClose: () => void;
    onSuccess?: () => void;
}

const MeetingTeacherPickDetailModal = ({
    isOpen,
    id,
    onClose,
    onSuccess
}: Props) => {

    const { user_info } = useAuth();

    const {
        nam_hoc,
        hoc_ky,
        dm_truong_id
    } = useCommonSelectedHook();

    const [lopId, setLopId] = useState(0);

    const [hocSinhs, setHocSinhs] = useState<any[]>([]);

    const [selectedStudentIds, setSelectedStudentIds] = useState<number[]>([]);

    const handleGetHocSinhs = async (lopId: number) => {

        const [hsRes, pickRes] = await Promise.all([
            hocSinhApi.Select({
                dm_he_id: 0,
                dm_khoi_id: 0,
                dm_lop_id: lopId,
                dm_truong_id,
                nam_hoc
            }),
            meetingPickApi.select(
                nam_hoc,
                hoc_ky
            )
        ]);

        if (!hsRes.is_success) {
            NotifyHelper.Error(hsRes.message ?? "Error");
            return;
        }

        const hocSinhs = hsRes.data ?? [];

        const pickedIds = new Set(
            (pickRes.data ?? []).map(
                (x: any) => x.ts_hocsinh_id
            )
        );

        setHocSinhs(
            hocSinhs.filter(
                (x: any) => !pickedIds.has(x.id)
            )
        );
    };

    const onSubmit = async () => {

        if (selectedStudentIds.length <= 0) {
            NotifyHelper.Error("Vui lòng chọn học sinh");
            return;
        }

        let success = true;

        for (const hsId of selectedStudentIds) {

            const res = await meetingPickApi.insert({
                id: 0,
                nam_hoc,
                hoc_ky,
                sis_giaovien_id: user_info?.sis_giaovien_id ?? 0,
                ts_hocsinh_id: hsId
            });

            if (!res.is_success) {
                success = false;
                break;
            }
        }

        if (success) {
            NotifyHelper.Success("Success");
            onSuccess?.();
            onClose();
        }
        else {
            NotifyHelper.Error("Error");
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            title="Chọn học sinh muốn gặp"
            onClose={onClose}
            sx={{ width: '50%' }}
        >
            <Box
                sx={{
                    display: "grid",
                    gap: 3
                }}
            >
                <FormControl>
                    <FormControl.Label>
                        Chọn lớp
                    </FormControl.Label>
                    <ComboboxLop
                        dm_truong_id={dm_truong_id}
                        nam_hoc={nam_hoc}
                        value={lopId}
                        onValueChanged={(value) => {

                            setLopId(value);

                            setSelectedStudentIds([]);

                            handleGetHocSinhs(value);
                        }}
                    />
                </FormControl>
                <MeetingPickGrid
                    hocSinhs={hocSinhs}
                    selectedStudentIds={selectedStudentIds}
                    setSelectedStudentIds={setSelectedStudentIds}
                />
            </Box>

            <ModalActions>
                <Button
                    text="Đóng"
                    onClick={onClose}
                />

                <Button
                    text="Lưu"
                    variant="primary"
                    onClick={onSubmit}
                />
            </ModalActions>
        </Modal>
    );
};

export default MeetingTeacherPickDetailModal;
